import * as React from "react";
import { Loader2, type LucideIcon } from "lucide-react";
import { cn } from "@/app/utils/tw-merge";

/** Loading state — Core idiom: spinner căn giữa py-12 trong card. */
export function Spinner({ className }: { className?: string }) {
  return (
    <Loader2
      className={cn("h-8 w-8 animate-spin text-muted-foreground", className)}
    />
  );
}

export function LoadingState({
  message,
  className,
}: {
  message?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 py-12",
        className
      )}
    >
      <Spinner />
      {message && (
        <p className="text-sm text-muted-foreground">{message}</p>
      )}
    </div>
  );
}

/** Empty state — icon w-16 muted-foreground/50 + text căn giữa py-12. */
export function EmptyState({
  icon: Icon,
  message,
  action,
  className,
}: {
  icon: LucideIcon;
  message: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 py-12",
        className
      )}
    >
      <Icon className="h-16 w-16 text-muted-foreground/50" />
      <p className="text-sm text-muted-foreground">{message}</p>
      {action}
    </div>
  );
}

/** Error state — với nút retry tuỳ chọn. */
export function ErrorState({
  message,
  onRetry,
  className,
}: {
  message: string;
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 py-12",
        className
      )}
    >
      <p className="text-sm text-destructive">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="text-sm text-primary underline-offset-4 hover:underline"
        >
          Retry
        </button>
      )}
    </div>
  );
}
